/**
 * Pagination constants used throughout the application
 */
export const PAGINATION_CONSTANTS = {
  DEFAULT_PAGE_SIZE: 5,
  PAGE_SIZE_OPTIONS: [5, 10, 20, 50],
} as const;

export default PAGINATION_CONSTANTS;
